// Utilities
import { defineStore } from 'pinia'
import defineAbilitiesFor from "../permissoes/index"
import User from '@/models/UserModel'
import { useSessionStorage } from "@vueuse/core";

interface userCognito {
  "username": string,
  "empresa": string[],
  "obra": string[],
  "roles": string[],
  "email": string,
  "email_verified": boolean,
  "name": string,
  "id_user": string,
  "pk": string,
  "sk": string,
  "tipo": string,
}

export default defineStore('user', {
  state: () => ({
    userProperties: null,
    _ultimaRotaVisitada: useSessionStorage('ultimaRota', ''),
    _ability: {}
  }),

  actions: {
    defineAbilities() {
      console.log('testando defineAbilities', this.user)
      this._ability = defineAbilitiesFor(this.user)
    },
    salvarUsuario(user: any, expiraEm = 0) {
      this.userProperties = user satisfies userCognito;
      localStorage.removeItem('user')
      if (user) {
        localStorage.setItem('expiraEm', JSON.stringify(expiraEm))
        localStorage.setItem('user', JSON.stringify(this.userProperties))
        this.defineAbilities()
        return this.userProperties
      }
    },
    novaRota(rota:string) {
      this._ultimaRotaVisitada = rota
      return this._ultimaRotaVisitada
    },
  },

  getters: {
    user: (state) => {
      console.log('get user', state.userProperties)
      console.trace()
      if (state.userProperties) {
        return state.userProperties
      }
      let usuarioLogado = localStorage.getItem('user')
      if (usuarioLogado) return new User(JSON.parse(usuarioLogado));
      else
        return new User({}) // TODO: CRIAR ESSA FUNÇAÕ DE LOGOUT // fazerLogout()
    },
    ability: (state) => {
      return state._ability
    },
    expiraEm: (state) => {
      const expiraEm = Number(localStorage.getItem('expiraEm'))
      return expiraEm || 0
    },
    ultimaRotaVisitada: (state) => {
      return state._ultimaRotaVisitada
    },
    loggedUser: state => {
      let usuarioLogado:any = localStorage.getItem('user')
      console.log('Get loggedUser', usuarioLogado)
      if (usuarioLogado) usuarioLogado = new User(JSON.parse(usuarioLogado));

      console.log('state.userProperties', state)
      const { name, email, username } = (usuarioLogado) ? usuarioLogado : {
        name: "",
        email: "",
        username: ""
      };
      return {
        displayName: name,
        email,
        id: username
      }
    }
  }

})
